export const handleWidth: IHandleWidth = 
(
  isTablet 
) => {
  if (isTablet) return "100%";

  return "38.5%";
};


type IHandleWidth = (
    isTablet:boolean, 
) => string
